import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.1065 2.10652C2.71493 1.73068 2.09279 1.73555 1.7072 2.12114C1.31668 2.51166 1.31668 3.14483 1.7072 3.53535L8.96023 10.7884L9.00001 10.8401V16C9.00001 16.2652 9.10536 16.5195 9.2929 16.7071L13.2929 20.7071C13.5789 20.9931 14.009 21.0786 14.3827 20.9239C14.7564 20.7691 15 20.4044 15 20V16.8282L20.092 21.9201C20.4825 22.3107 21.1157 22.3107 21.5062 21.9201C21.8918 21.5345 21.8967 20.9124 21.5208 20.5209L3.1065 2.10652ZM15 11.1716V10.8401L19.7926 4.60968C20.0249 4.30772 20.0654 3.9 19.8971 3.55822C19.7289 3.21644 19.381 2.99997 19 2.99997H6.82837L8.82837 4.99997H16.9691L13.4297 9.60128L15 11.1716ZM11 12.8282V15.5858L13 17.5858V14.8282L11 12.8282Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.39957 1.60054C2.17893 1.3799 1.82119 1.3799 1.60054 1.60054C1.3799 1.82119 1.3799 2.17893 1.60054 2.39957L5.935 6.73403V10.793C5.935 11.0754 6.0472 11.3463 6.24693 11.546L8.24693 13.546C8.91784 14.2169 10.065 13.7418 10.065 12.793V10.864L13.6005 14.3996C13.8212 14.6202 14.1789 14.6202 14.3996 14.3996C14.6202 14.1789 14.6202 13.8212 14.3996 13.6005L10.065 9.26597V9.26393L8.935 8.13393V8.13597L3.86409 3.06506H3.86613L2.73613 1.93506H2.73409L2.39957 1.60054ZM8.935 9.73403L7.065 7.86403V10.766L8.935 12.636V9.73403ZM9.15934 6.51777C9.12325 6.56417 9.09125 6.61324 9.06353 6.66441L9.83238 7.43325L10.065 7.19391L12.8183 3.65391C13.3624 2.95435 12.8639 1.93506 11.9777 1.93506H4.33419L5.46419 3.06506H11.8448L9.15934 6.51777Z"
  />
);

export const CancelFilterIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="CancelFilter" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
